import { useState } from 'react'

type Props = {
  initialRowsPerPage?: number
}

const INITIAL_ROWS_PER_PAGE_DEFAULT = 5

export const useTablePageState = (props?: Props) => {
  const initialRowsPerPage = props
    ? props.initialRowsPerPage || INITIAL_ROWS_PER_PAGE_DEFAULT
    : INITIAL_ROWS_PER_PAGE_DEFAULT
  const [page, _setPage] = useState(0)
  const [rowsPerPage, _setRowsPerPage] = useState(initialRowsPerPage)

  const setPage = (newPage: number) => {
    _setPage(newPage)
  }

  const setRowsPerPage = (newRowsPerPage: number) => {
    _setPage(0)
    _setRowsPerPage(newRowsPerPage)
  }

  return {
    page,
    rowsPerPage,
    setPage,
    setRowsPerPage,
  }
}
